import * as he from "he";

export interface EncodeOptions {
  /** Also encode " and ' (needed inside attribute values). */
  quotes: boolean;
  /** Use named entities (&copy;) where one exists, otherwise numeric (&#169;). */
  named: boolean;
  /** Encode only non-ASCII characters (leave < > & untouched). */
  nonAsciiOnly: boolean;
}

export const DEFAULT_ENCODE: EncodeOptions = { quotes: true, named: true, nonAsciiOnly: false };

/** Pure text-in, text-out. Never parses HTML, so nothing can execute. */
export function encodeEntities(input: string, o: EncodeOptions = DEFAULT_ENCODE): string {
  if (o.nonAsciiOnly) {
    return he.encode(input, { allowUnsafeSymbols: true, useNamedReferences: o.named });
  }
  let out = he.encode(input, { useNamedReferences: o.named });
  // he.encode escapes everything non-ASCII plus the unsafe symbols; it also
  // encodes quotes as &quot; / &#x27;. Normalise or strip them per the option.
  out = out.replace(/&apos;|&#x27;/g, "&#39;");
  if (!o.quotes) out = out.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
  return out;
}

/** Decodes entities only; existing tags are left exactly as typed. */
export function decodeEntities(input: string): string {
  return he.decode(input);
}
